var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSignatureSolid = function SvgSignatureSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9.604,
    viewBox: "0 0 16 9.604",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "signature-solid",
    d: "M15.612,67.187c-1.3.088-3.144,1.368-4.079,1.788a5.176,5.176,0,0,1-1.9.61c-.565,0-.65-.405-.533-1.3.028-.2.293-1.981-1.068-1.9-.628.038-1.608.62-4.239,3.151l1.038-2.593a2.161,2.161,0,0,0-3.244-2.571l-1.373.923a.4.4,0,0,0-.123.553l.43.675a.4.4,0,0,0,.553.123l1.451-.973a.558.558,0,0,1,.818.678L.884,72.492a.8.8,0,0,0,.743,1.1.791.791,0,0,0,.565-.235c1.055-1.055,3.869-3.769,5.282-4.9a2.6,2.6,0,0,0,.515,2.1,2.11,2.11,0,0,0,1.638.633,6.325,6.325,0,0,0,2.558-.75c.825-.37,2.476-1.566,3.461-1.646a.4.4,0,0,0,.38-.4v-.8A.4.4,0,0,0,15.612,67.187Z",
    transform: "translate(-0.027 -63.986)",
    fill: "#3c3e69"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignatureSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signature-solid.c965ae97.svg";
export { ForwardRef as ReactComponent };